import { cartonLabelVoidOutcomeSchema } from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label-void";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const voidConsolidationCartonLabel = {
  name: "voidConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    expectedRedoShipmentId: z.string().min(1).max(200),
  }),
  output: cartonLabelVoidOutcomeSchema,
};
